export function createStore(initial) {
	let state = initial;
	const listeners = new Set();

	return {
		get() {
			return state;
		},
		set(patch) {
			state = Object.assign({}, state, typeof patch === 'function' ? patch(state) : patch);
			listeners.forEach((fn) => fn(state));
		},
		subscribe(fn) {
			listeners.add(fn);
			return () => listeners.delete(fn);
		},
	};
}
